<template>
    <propertyPop ref="pop" type="photo" @hide="beforeHide"
        :class="{ 'photo-grid': isGridView, 'zoom-mode': active, 'zoom-in': isZoomIn, 'pop-photo-cate-view': showPhotoCategories, bottom: isEnd, hotleadmode:showHotleadForm, vertical: isListView }"
        v-ga:pop="{ pageType: 'vdppphoto', glb: glb, state: dpp }">
        <template v-slot:header>
            <div>
                <div class="f6 flex left property-pop-buttons">
                    <button type="button" @click="toggleView" class="link"><i
                            :class="isGridView ? 'icon-deck' : 'icon-galleryview'"></i> <span>{{ isGridView ? 'List' :
                                'Grid' }}</span></button>
                </div>
            </div>
        </template>
        <template v-slot:body>
            <div class="property-popphoto-single" ref="container">
                <div class="property-photo-nav" v-if="showPhotoCategories" ref="photoNav">
                    <ul>
                        <li v-for="item in getCategories" :data-nav="item.cateIndex"
                            @click="updateById(item.cateIndex, 0)">
                            <img :title="`${item.tag} ${item.tag ? '-' : ''} ${dpp.geo.formatAddress} photo ${item.index + 1}${item.count ? ` of ${item.count}` : ''}`"
                                :alt="dpp.geo.formatAddress" :src="item.path + (glb.isPhone ? item._p : item._r)">
                            <span v-if="item.tag">{{ `${item.tag}` }}</span>
                        </li>
                    </ul>
                </div>
                <div class="property-popphoto-single-list" ref="thumbnail" @scroll="onScroll">
                    <ul>
                        <li v-for="(item, index) in photoList" class="item-photo" @click="onClickPhoto(index)"
                            :data-index="index" :data-cateIndex="item.cateIndex" :data-photoIndex="item.index">
                            <img loading="lazy" :alt="item.cate"
                                :src="item.src ? item.src : (item.path + (glb.isPhone ? item._p : item._r))">
                        </li>
                        <li class="item-form" ref="hotleadForm" :data-index="photoList.length">
                            <span
                                v-if="!removeAds"
                                ref="dppAdsSplitSentinel"
                                class="dpp-ads-split-sentinel"
                                aria-hidden="true"
                            ></span>
                            <SplitTreatments
                                v-if="!removeAds && dppAdsSpotViewed"
                                :names="['movoto-dpp-ads-CW-4649']"
                            >
                                <template #default="{ treatments, isReady }">
                                    <mvtAds
                                        v-if="isReady && isDppAdsOn(treatments)"
                                        :options="{ type: 'dpp', index: 0, isActive: dpp.isActive }"
                                        :key="'dpp_0_' + dpp.isActive"
                                    />
                                </template>
                            </SplitTreatments>
                            <div class="property-popphoto-single-form">
                                <mvtHotleadForm :options="hotleadOpt" />
                            </div>
                        </li>
                    </ul>
                </div>

                <a @click="zoomOut" class="single-close-zoom"><i class="icon-times"></i></a>
                <span class="single-close-zoom-text" v-if="imageIndex < photoList.length">{{ imageIndex + 1 }} of {{ photoList.length }}</span>
                <div ref="figure" v-if="getCurrentPhoto" @click="onClickImg" @mousemove="mouseMove"
                    class="single-img-zoom" :class="{ moving: moving, 'min-zoom': zoomLevel < minZoomIn }" :style="coreStyle">
                    <img ref="prevPhoto" v-if="isListView && getPrevPhoto" class="prev" />
                    <img ref="currentPhoto" @load="onImgLoad" @touchstart="touchStart" class="current"
                        :class="{'current-watermark': showWatermark()}" @touchend="touchEnd" @touchmove="touchMove"
                        :src="getCurrentPhoto.src_l ? getCurrentPhoto.src_l : (getCurrentPhoto.path + getCurrentPhoto._l)" />
                    <img ref="nextPhoto" v-if="isListView &&getNextPhoto" class="next" />
                </div>
                <div v-if="prepareHotleadForm" class="property-popphoto-single-form slider">
                    <mvtHotleadForm :options="hotleadOpt" />
                </div>
                <button type="button" :class="{ invisible: isFirst }" v-if="!isListView" class="popphoto-single-left" @click="_prev"><i class="f4 icon-angle-left"></i></button>
                <button type="button" :class="{ invisible: isLast }" v-if="!isListView" class="popphoto-single-right" @click="_next"><i class="f4 icon-angle-right"></i></button>
            </div>
        </template>
    </propertyPop>
</template>
<script src="./property-popphotosingle.js"></script>

<style lang="scss">
@use "./property-popphotosingle.scss" as *;
</style>
